import { render, staticRenderFns } from "./OrderMenuItem.vue?vue&type=template&id=4acfed9e"
import script from "./OrderMenuItem.vue?vue&type=script&lang=js"
export * from "./OrderMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports